import { isCustomLine, isDeliveryLine } from '../../global/Firebase/cartLineType'

export const countWorkingHoursStats = (workingHours, ROLES) => {
  var hoursQuantity = 0
  var daysQuantity = 0
  var amount = 0
  var bonusAmount = 0
  for (const [index, value] of workingHours.entries()) {
    if (value.salaryType === 'hour' || !value.salaryType) {
      const hours = value.endHour.value - value.startHour.value
      hoursQuantity += hours
      amount += (value.amount ? value.amount : (hours * (ROLES[value.role].salary || 0)))
      bonusAmount += (value.employeeBonusAmount || 0)
    } else if (value.salaryType === 'day') {
      daysQuantity += 1
      amount += value.amount
      bonusAmount += (value.employeeBonusAmount || 0)
    } else {
      amount += value.amount
      bonusAmount += (value.employeeBonusAmount || 0)
    }
  }
  return [amount, hoursQuantity, daysQuantity, bonusAmount]
}

export const countSalesByProducts = (sales, store=null) => {
  var salesByProducts = []
  if (sales && sales.length > 0) {
    var cartItems = {}
    for (const [index, sale] of sales.entries()) {
      if (store == null || sale.store === store) {
        for (const [index, cartItem] of sale.cartItems.entries()) {
          // Group custom products by name (legacy 'customProduct'+name key), delivery under
          // a single 'delivery' key, real products by id. lineType-aware so Supabase-read
          // items (unique id, no category 'customProduct' sentinel) still group correctly
          // instead of fragmenting into one phantom row per cart line.
          const itemKey = isCustomLine(cartItem)
            ? ('customProduct' + cartItem.name)
            : isDeliveryLine(cartItem)
              ? 'delivery'
              : cartItem.id
          
          if (cartItems[itemKey] != null) {
            cartItems[itemKey] = {...cartItems[itemKey],
              quantity: (cartItem.quantity || 0) + cartItems[itemKey].quantity,
              finalItemPrice: (cartItem.finalItemPrice || 0) + cartItems[itemKey].finalItemPrice,
              checkQuantity: cartItems[itemKey].checkQuantity + 1,
              purchasePrice: ((cartItem.purchasePrice || 0)*(cartItem.quantity || 0)) + cartItems[itemKey].purchasePrice,
              margin: ((cartItem.finalItemPrice || 0) - (cartItem.purchasePrice || 0) * (cartItem.quantity || 0)) + cartItems[itemKey].margin,
            }
          } else {
            cartItems[itemKey] = {...cartItem,
              checkQuantity: 1,
              purchasePrice: (cartItem.purchasePrice || 0) * (cartItem.quantity || 0),
              margin: (cartItem.finalItemPrice || 0) - (cartItem.purchasePrice || 0) * (cartItem.quantity || 0),
            }
          }
        }
      }
    }
    for (var key in cartItems) {
      salesByProducts.push(cartItems[key])
    }
    salesByProducts.sort((a, b) => b.margin - a.margin)
  }
  return salesByProducts
}